import { Outlet } from 'react-router'

import { PrintProvider, usePrintContext } from '@/context/PrintContext'
import { InsuranceParamsProvider } from '../context/InsuranceParamsProvider'
import { Header } from './components/Header'

const WizardLayout2 = () => {
  const { printMode } = usePrintContext()

  return (
    <InsuranceParamsProvider>
      {!printMode && <Header />}

      <Outlet />

    </InsuranceParamsProvider>
  )
}


export const WizardLayout = () => <PrintProvider>
  <WizardLayout2 />
</PrintProvider> 
